"use client";

import { useLocaleCtx } from "@/contexts/locale";
import { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

type Query = {
  href?: `/${string}`;
  search?: {
    [key: string]: string;
  };
};

export default function useLocalRouter() {
  const { lang } = useLocaleCtx();
  const pathname = usePathname();
  const r = useRouter();
  const sParamms = useSearchParams();

  function builder(query: Query) {
    let newUrl = pathname;

    if (query.href) {
      newUrl = "/" + lang + query.href;
    }

    const p = sParamms.toString();

    if (p) {
      const allParanm = Object.fromEntries(sParamms.entries());

      const s = new URLSearchParams({
        ...allParanm,
        ...(query?.search ?? {}),
      });

      // remove empty values
      s.forEach((value, key) => {
        if (!value) {
          s.delete(key);
        }
      });

      newUrl = newUrl + "?" + s;
    } else if (query.search) {
      const s = new URLSearchParams(query.search).toString();
      newUrl = newUrl + "?" + s;
    }

    return newUrl;
  }

  function push(query: Query, options: NavigateOptions = {}) {
    const newUrl = builder(query);

    r.push(newUrl, options);
  }

  function replace(query: Query) {
    const newUrl = builder(query);

    r.replace(newUrl);
  }

  return { push, replace };
}
